import { useMemo } from 'react';

import { useAuth } from 'context/AuthContext';
import { canRenounceDynamics } from 'pages/Preference/communication-preferences';

export function useCanRenouncePreferences(): boolean {
  const { userInfo, realCycle, cycleSelected } = useAuth();

  return useMemo(() => {
    const cycle = realCycle?.find((item: any) => item._id === cycleSelected?._id);

    return (
      cycle?.status === 'open' &&
      canRenounceDynamics({
        isManager: !!userInfo?.is_manager,
        cadMissao: userInfo?.cad_missao,
        tipoRo: userInfo?.tipo_ro,
      })
    );
  }, [userInfo, realCycle, cycleSelected]);
}
